import { Tooltip } from '@chakra-ui/react';

export default {
  Tooltip: {
    component: Tooltip,
    props: {
      label: 'aad asdasd',
      hasArrow: true,
    },
    children: ({ content }) => ({
      children: content,
    }),
  },
};
